import config from '../config';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogTags } from './datadogConstants';

export function initializeDatadog(): void {
  const { datadogClientToken, datadogEnv } = config;

  datadogLogs.init({
    clientToken: datadogClientToken,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    service: 'browser/cato',
    sessionSampleRate: 100,
    env: datadogEnv,
    beforeSend: log => {
      const logMessage = log.message || '';
      const isAmazonConnectLog = /\[\d{4}-\d{2}-\d{2}T[\d:.]+Z]\s+\[\w+]/.test(logMessage);

      if (isAmazonConnectLog) {
        log.source = 'amazon-connect';
      }

      return true;
    }
  });

  datadogLogs.setGlobalContext({
    ...datadogLogs.getGlobalContext(),
    ...datadogTags
  });

  datadogLogs.logger.addTag('team', datadogTags.team);
  datadogLogs.logger.addTag('costcenter', datadogTags.costcenter);
  datadogLogs.logger.addTag('appgroup', datadogTags.appgroup);
  datadogLogs.logger.addTag('retention', datadogTags.retention);
}
